export const financialInstitutionMap = {
    '002': '산업은행',
    '003': '기업은행',
    '004': '국민은행',
    '007': '수협은행/수협중앙회',
    '011': 'NH농협은행',
    '012': '농협중앙회(지역농축협)',
    '020': '우리은행',
    '023': 'SC제일은행',
    '027': '한국씨티은행',
    '031': 'iM뱅크(대구은행)',
    '032': '부산은행',
    '034': '광주은행',
    '035': '제주은행',
    '037': '전북은행',
    '039': '경남은행',
    '045': '새마을금고',
    '048': '신협',
    '050': '저축은행중앙회(상호저축은행)',
    '051': '기타외국은행',
    '054': 'HSBC은행',
    '055': '도이치은행',
    '057': '제이피모간체이스은행',
    '059': '미쓰비시도쿄은행',
    '060': 'BOA은행',
    '061': 'BNP파리바은행',
    '062': '중국공상은행',
    '063': '중국은행',
    '064': '산림조합중앙회',
    '067': '중국건설은행',
    '071': '우체국',
    '081': '하나은행',
    '088': '신한은행',
    '089': '케이뱅크',
    '090': '카카오뱅크',
    '092': '토스뱅크',
    '103': 'SBI저축은행',
    '209': '유안타증권',
    '218': 'KB증권',
    '221': '상상인증권',
    '224': 'BNK투자증권',
    '225': 'IBK투자증권',
    '227': '다올투자증권',
    '238': '미래에셋증권',
    '240': '삼성증권',
    '243': '한국투자증권',
    '247': 'NH투자증권',
    '261': '교보증권',
    '262': '하이투자증권',
    '263': '현대차증권',
    '264': '키움증권',
    '265': 'LS증권',
    '266': 'SK증권',
    '267': '대신증권',
    '269': '한화투자증권',
    '270': '하나증권',
    '271': '토스증권',
    '278': '신한금융투자',
    '279': 'DB금융투자',
    '280': '유진투자증권',
    '287': '메리츠증권',
    '288': '카카오페이증권',
    '290': '부국증권',
    '291': '신영증권',
    '292': '케이프투자증권',
    '294': '한국포스증권',
};

export const financialInstitutionOptions = [
    { value: '', label: '--' },
    ...Object.entries(financialInstitutionMap).map(([value, label]) => ({ value, label })),
];

export const getFinancialInstitutionName = (code) => {
    if (!code) {
        return '';
    }

    return financialInstitutionMap[String(code)] || String(code);
};
